const supportConst = {
  page: {
    contactSupport: "contact_support",
    vp: "vp",
    reportUser: "report_user",
  },
};

export default supportConst;
